import React, { useState } from 'react';
import { api } from '../../App';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Landmark, Wallet } from 'lucide-react';

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const WalletCard = ({ status, onChange, linkBank }) => {
  const [amount, setAmount] = useState('');
  const [busy, setBusy] = useState(false);
  const bank = status?.bank;
  const ready = bank?.transfers_active;

  const cashOut = async () => {
    setBusy(true);
    try {
      const res = await api.post('/sb-live/cashout', { amount: parseFloat(amount) });
      toast.success(res.data.message);
      setAmount('');
      onChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Cash-out failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-5 rounded-xl bg-white/5 border border-white/10 space-y-4" data-testid="live-wallet-card" data-sb-live>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-white font-semibold"><Wallet className="w-5 h-5 text-[#00E676]" /> Market wallet (real money)</div>
        <span className="text-2xl font-bold text-[#00E676]" data-testid="live-wallet-cash">{money(status?.wallet?.cash)}</span>
      </div>
      <p className="text-xs text-gray-500">Cashback and money from shares you sold land here. Cashed out so far: {money(status?.wallet?.cashed_out)}</p>
      {!ready ? (
        <Button onClick={linkBank} className="btn-secondary w-full" data-testid="link-bank-btn">
          <Landmark className="w-4 h-4 mr-2" /> {bank ? 'Finish bank setup with Stripe' : 'Link your bank with Stripe'}
        </Button>
      ) : (
        <div className="flex gap-2">
          <Input type="number" min="10" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Min $10" className="input-dark" data-testid="cashout-amount-input" />
          <Button onClick={cashOut} disabled={busy || !(parseFloat(amount) >= 10)} className="btn-primary" data-testid="cashout-btn">Cash out to bank</Button>
        </div>
      )}
    </div>
  );
};
